// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4419":"4b32cc25","5618":"4b32cc25"}[chunkId] + ".chunk.css";
};